import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AppService } from '../app.service';
import { LoaderService } from '../loader/loader.service';

@Component({
  templateUrl: './votes.component.html',
  styleUrls: ['./votes.component.css'],
  providers: [AppService, LoaderService]
})
export class VotesComponent implements OnInit {
  error: String;

  constructor(private appService: AppService,
    private loaderService: LoaderService
  ) {}

   ngOnInit() {}

  onSubmit(fv: NgForm) {
    if (!fv.value.possibleAnswer || !fv.value.messagesNumber ) {
      alert('Vous ne pouvez pas laisser de champ(s) vide(s)');
    } else {
      this.loaderService.show();
      this.appService.sendVotes({
        possibleAnswer: fv.value.possibleAnswer,
        messagesNumber: fv.value.messagesNumber
      })
      .subscribe((res) => {
        console.log("res:", res);
        this.loaderService.hide();
      }, (err) => {
        this.loaderService.hide();
        this.error = err;
      });
    }
  }
}



// WEBPACK FOOTER //
// /www/sms-simulator/sms-front/src/app/votes/votes.component.ts